import React from 'react';

export default function LyricsRecordPreview({ text, emptyText }) {
  const lines = previewLines(text);
  if (!lines.length) {
    return <div className="no-image"><span>{emptyText}</span></div>;
  }
  return (
    <div className="lyrics-record-cover">
      <div className="lyrics-record-cover__icon">♪</div>
      <div className="lyrics-record-cover__lines">
        {lines.map((line, index) => (
          <span key={`${index}-${line}`}>{line}</span>
        ))}
      </div>
    </div>
  );
}

export function LyricsRecordModal({ record, title, emptyText, onClose }) {
  if (!record) return null;
  const text = getLyricsText(record);
  return (
    <div className="lyrics-record-modal" onClick={onClose}>
      <div className="lyrics-record-modal__content" onClick={(e) => e.stopPropagation()}>
        <div className="lyrics-record-modal__header">
          <strong>{title}</strong>
          <button onClick={onClose}>×</button>
        </div>
        <pre>{text || emptyText}</pre>
      </div>
    </div>
  );
}

export function getLyricsText(record) {
  return String(record?.lyrics || record?.resultText || record?.content || '').trim();
}

function previewLines(text) {
  return String(text || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean)
    .slice(0, 6);
}
